(function () {
  'use strict';

  function setHeaderState() {
    document.documentElement.classList.toggle('ccf-scrolled', window.scrollY > 18);
  }

  function markActiveHeaderLink() {
    var path = window.location.pathname || '/';
    document.querySelectorAll('.ccf-header-top-links a, .ccf-quick-nav a').forEach(function (link) {
      var target = new URL(link.href, window.location.origin).pathname;
      var active = target === '/' ? path === '/' : path.indexOf(target) === 0;
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }

  function connectMotion() {
    var targets = document.querySelectorAll(
      '.ccf-dynamic-products, .featured-collection, .ccf-paths, .ccf-category-tiles-section, .ccf-sale-spotlight, .ccf-story-band'
    );
    if (!targets.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(function (target) {
        target.classList.add('is-in-view');
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in-view');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.06 });
    targets.forEach(function (target) {
      if (target.dataset.ccfPrecisionMotion === 'true') return;
      target.dataset.ccfPrecisionMotion = 'true';
      target.classList.add('ccf-precision-enter');
      observer.observe(target);
    });
  }

  function tuneWelcomeOffer() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      host.style.setProperty('--forms-accent-color', '#3590cc', 'important');
      host.style.setProperty('--forms-discount-code-color', '#287aa9', 'important');
      host.style.setProperty('--body-text-color', '#526875', 'important');
      host.style.setProperty('--heading-text-color', '#102a3a', 'important');
      host.style.setProperty('--form-text-color', '#102a3a', 'important');
      host.style.setProperty('--form-background-color', '#f8fafb', 'important');
      host.style.setProperty('--button-text-color', '#ffffff', 'important');
      host.style.setProperty('--button-background-color', '#3590cc', 'important');
      host.style.setProperty('--button-close-background-color', '#ffffff', 'important');
      host.style.setProperty('--button-close-color', '#102a3a', 'important');
      host.style.setProperty('--container-background-color', '#f8fafb', 'important');
      host.style.setProperty('--form-field-border-radius', '9px', 'important');
      host.style.setProperty('--button-border-radius', '9px', 'important');
      host.style.setProperty('--container-border-radius', '16px', 'important');
      host.style.setProperty('--container-shadow', '0 18px 48px rgba(16,42,58,.18)', 'important');
    });
  }

  function init() {
    document.documentElement.classList.add('ccf-precision-ready');
    setHeaderState();
    markActiveHeaderLink();
    connectMotion();
    tuneWelcomeOffer();
  }

  var headerFrame = 0;
  window.addEventListener('scroll', function () {
    if (headerFrame) return;
    headerFrame = window.requestAnimationFrame(function () {
      headerFrame = 0;
      setHeaderState();
    });
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
